import React, { useState } from "react";
import { Box, IconButton, Popover, Stack, TextField, Typography } from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import type { SxProps, Theme } from "@mui/material/styles";

interface PtiMeasurementInfoFieldProps {
    label: string;
    infoText: string;
    helperText: string;
    value: string;
    onChange: (value: string) => void;
    fieldSx?: SxProps<Theme>;
}

export const PtiMeasurementInfoField: React.FC<PtiMeasurementInfoFieldProps> = ({
    label,
    infoText,
    helperText,
    value,
    onChange,
    fieldSx,
}) => {
    const [infoAnchor, setInfoAnchor] = useState<HTMLElement | null>(null);

    return (
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" alignItems="center" spacing={0.25} sx={{ mb: 0.5 }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600}>
                    {label}
                </Typography>
                <IconButton
                    size="small"
                    aria-label={`${label} scale information`}
                    onClick={(event) => setInfoAnchor(event.currentTarget)}
                    sx={{ p: 0.25 }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                </IconButton>
            </Stack>
            <TextField
                fullWidth
                size="small"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                helperText={helperText}
                sx={fieldSx}
            />
            <Popover
                open={Boolean(infoAnchor)}
                anchorEl={infoAnchor}
                onClose={() => setInfoAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <Typography variant="body2" sx={{ p: 1.5, maxWidth: 280 }}>
                    {infoText}
                </Typography>
            </Popover>
        </Box>
    );
};
